
(function(){
  function initGallery(){
    var main=document.getElementById('productPreview');
    var thumbs=[].slice.call(document.querySelectorAll('#galleryThumbs .gthumb'));
    var prev=document.getElementById('galPrev');
    var next=document.getElementById('galNext');
    if(!main||!thumbs.length) return;
    var cur=0;

    // preload every gallery image up front so swapping is instant and never shows blank/broken
    thumbs.forEach(function(t){ var im=new Image(); im.src=t.src; });

    function select(i){
      cur=(i+thumbs.length)%thumbs.length;
      var t=thumbs[cur];
      var pos = t.dataset.pos || 'center';
      if(t.complete && t.naturalWidth){
        main.src=t.src;
        main.style.objectPosition = pos;
      } else {
        // not loaded yet: wait for it, then swap, so we never flash a broken image
        var loader=new Image();
        loader.onload=function(){ if(cur === i % thumbs.length || cur === (i+thumbs.length)%thumbs.length){ main.src=t.src; main.style.objectPosition=pos; } };
        loader.src=t.src;
      }
      thumbs.forEach(function(tt,j){ tt.style.borderColor = (j===cur)?'var(--pink-600)':'transparent'; });
    }
    thumbs.forEach(function(t,i){ t.addEventListener('click',function(){ select(i); }); });
    if(prev) prev.addEventListener('click',function(){ select(cur-1); });
    if(next) next.addEventListener('click',function(){ select(cur+1); });
    var sqCard=document.querySelector('.shape-card[data-shape="square"]');
    var rcCard=document.querySelector('.shape-card[data-shape="rect"]');
    if(sqCard) sqCard.addEventListener('click',function(){ select(0); });
    if(rcCard) rcCard.addEventListener('click',function(){ select(1); });
    select(0);
  }
  if(document.readyState!=='loading') initGallery(); else document.addEventListener('DOMContentLoaded', initGallery);
})();
